import Masthead from './components/Masthead';
import LeadHero from './components/LeadHero';
import BreakingTimeline from './components/BreakingTimeline';
import PeopleGrid from './components/PeopleGrid';
import CaseArchive from './components/CaseArchive';
import CategoryBrowse from './components/CategoryBrowse';
import TrendingSection from './components/TrendingSection';
import FaqBlock from './components/FaqBlock';
import TipCta from './components/TipCta';
import FooterBlock from './components/FooterBlock';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-[#f6f1e8] text-[#262019]">
      <Masthead />
      <main>
        <LeadHero />
        <BreakingTimeline />
        <PeopleGrid />
        <CaseArchive />
        <CategoryBrowse />
        <TrendingSection />
        <FaqBlock />
        <TipCta />
      </main>
      <FooterBlock />
      <BackToTop />
    </div>
  );
}